import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
/**
 * Represents the KendoReact FieldWrapper component.
 * It's designed to wrap the field editor, Label, Hint and Error components.
 * The FieldWrapper supports only single editor inside it.
 */
export var FieldWrapper = function (props) {
    var fieldClassName = classNames({
        'k-form-field': true,
        'k-rtl': props.dir === 'rtl'
    }, props.className);
    return (React.createElement("div", { className: fieldClassName, style: props.style }, props.children));
};
FieldWrapper.displayName = 'KendoReactFieldWrapper';
//# sourceMappingURL=FieldWrapper.js.map